export const SET_SHIPPING_ADDRESS = 'set_shipping_address';
export const SET_ORDER_ITEMS = 'set_order_items';
export const SET_PAYMENT_METHOD = 'set_payment_method';


export type ShippingAddressAction = {
    type: typeof SET_SHIPPING_ADDRESS;
    payload: any
}

export type OrderItemsAction = {
    type: typeof SET_ORDER_ITEMS;
    payload: any
}

export type PaymentMethodAction = {
    type: typeof SET_PAYMENT_METHOD;
    payload: any
}

export type OrderActionsType = 
    ShippingAddressAction |
    OrderItemsAction |
    PaymentMethodAction